import template from './auth.jade';

export default () => {
  return {
    template,
    scope: {},
    replace: true,
    controller: [
      '$scope',
      'analyticsService',
      function(
        $scope,
        analyticsService
      ) {
      analyticsService.showAuthorized();

      $scope.loginTab = function() {
        analyticsService.loginTab();
      };

      $scope.registrationTab = function() {
        analyticsService.registrationTab();
      };

      this.mergeData = {
        visible: false,
      };
      this.enterEmailData = {
        visible: false,
      };

      }],
    controllerAs: 'AuthCtrl',
  };
};
